import { CONFIG } from '../../../config'

const { ENVIROMENT } = CONFIG
const BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/dashboard`

export const urlGetVeiculosEmRotaStats = (tp_id, pInicial, pFinal) =>
  `${BASE_URL}/rota-veiculos-stats?tp_id=${tp_id}&pInicial=${pInicial}&pFinal=${pFinal}`

export const urlGetEntregasVeiculo = (fleet_id, tp_id) =>
  `${BASE_URL}/rota-veiculos-stats/entregas/${fleet_id}/${tp_id}`

export const urlGetAcompanhamentoPicking = (tp_id, pInicial, pFinal) =>
  `${BASE_URL}/acompanhamento-picking?tp_id=${tp_id}&pInicial=${pInicial}&pFinal=${pFinal}`

export const urlGetPainelMonitoramentoEntregas = (
  tp_id,
  user_id,
  pInicial,
  pFinal,
  analista_entrega_id,
) => {
  const analistaParam = analista_entrega_id ? `&analista_entrega_id=${analista_entrega_id}` : ''
  return `${BASE_URL}/painel-monitoramento-entregas?tp_id=${tp_id}&user_id=${user_id}&pInicial=${pInicial}&pFinal=${pFinal}${analistaParam}`
}

export const urlGetPainelMonitoramentoEntregasOcorrenciasEntrega = (
  deliveryStepVehicleId,
  userId,
) =>
  `${BASE_URL}/painel-monitoramento-entregas/entrega/${deliveryStepVehicleId}/ocorrencias-entrega?user_id=${userId}`

export const urlGetPainelMonitoramentoEntregasRotaInfo = (fleetId, userId) =>
  `${BASE_URL}/painel-monitoramento-entregas/rota/${fleetId}/info?user_id=${userId}`

export const urlGetPainelDelegacaoRotas = (userId, analistaOrigemId, rotas, pInicial, pFinal) =>
  `${BASE_URL}/painel-monitoramento-entregas/delegacao/rotas?user_id=${userId}&analista_origem_id=${analistaOrigemId}&rotas=${rotas}&pInicial=${pInicial}&pFinal=${pFinal}`

export const urlPostPainelDelegacaoRotas = () =>
  `${BASE_URL}/painel-monitoramento-entregas/delegacao/rotas`

export const urlGetPainelDelegacaoTps = (userId, analistaOrigemId) =>
  `${BASE_URL}/painel-monitoramento-entregas/delegacao/tps?user_id=${userId}&analista_origem_id=${analistaOrigemId}`

export const urlGetPainelDelegacaoVeiculos = (userId, analistaOrigemId, tpId) =>
  `${BASE_URL}/painel-monitoramento-entregas/delegacao/veiculos?user_id=${userId}&analista_origem_id=${analistaOrigemId}&tp_id=${tpId}`

export const urlPostPainelDelegacaoVeiculos = () =>
  `${BASE_URL}/painel-monitoramento-entregas/delegacao/veiculos`

export const urlPutPainelDelegarRotaAnalista = fleetId =>
  `${BASE_URL}/painel-monitoramento-entregas/rota/${fleetId}/delegar-analista`

export const urlGetPainelAssumirRotas = (userId, analistaOrigemId, rotas, pInicial, pFinal) =>
  `${BASE_URL}/painel-monitoramento-entregas/assumir/rotas?user_id=${userId}&analista_origem_id=${analistaOrigemId}&rotas=${rotas}&pInicial=${pInicial}&pFinal=${pFinal}`

export const urlPostPainelAssumirRotas = () =>
  `${BASE_URL}/painel-monitoramento-entregas/assumir/rotas`

export const urlGetPainelAssumirVeiculos = (userId, analistaOrigemId) =>
  `${BASE_URL}/painel-monitoramento-entregas/assumir/veiculos?user_id=${userId}&analista_origem_id=${analistaOrigemId}`

export const urlPostPainelAssumirVeiculos = () =>
  `${BASE_URL}/painel-monitoramento-entregas/assumir/veiculos`

export const urlSavePainelMonitoramentoEntregasOcorrenciaEntrega = (
  deliveryStepVehicleId,
  userId,
) =>
  `${BASE_URL}/painel-monitoramento-entregas/entrega/${deliveryStepVehicleId}/ocorrencias-entrega?user_id=${userId}`
